// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

import { Api } from "#/api";
import { ProductResultInterface } from "../../../../common/interfaces/conversionworld/Products";

import { Accordion } from "#/components/accordion/Accordion";
import { LoadMoreButton } from "../../../../components/load_more_button/LoadMoreButton";
import { ProductList } from "../ProductList";
import { Product } from "#/common/interfaces/conversionworld/Product";
import { Pagination } from "#/common/interfaces/conversionworld/Pagination";
import { TextModule } from "#/common/interfaces/conversionworld/TextModule";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    LoadMoreButton,
    ProductList,
  },
})
export class ProductListVanPartnerModule extends ModuleBase {
  private products: Product[] = [];
  private pagination: Pagination | null = null;
  private currentPage = 1;
  private morePages = true;
  private isLoadingMore = false;

  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  public loadMore() {
    this.isLoadingMore = true;
    this.currentPage += 1;
    this.getProducts(this.currentPage);
  }

  get pageCount() {
    return this.pagination ? this.pagination.page_count : 0;
  }

  get total() {
    return this.pagination ? this.pagination.total_count : 0;
  }

  get textModules() {
    return this.instance["textModules"] || [];
  }

  public created() {
    this.getProducts(this.currentPage);
    this.$eventBus.$on("conversion-world-close-filter", this.handleCloseFilter);
  }

  public beforeDestroy() {
    this.$eventBus.$off(
      "conversion-world-close-filter",
      this.handleCloseFilter
    );
  }

  public handleCloseFilter() {
    this.currentPage = 1;
    this.getProducts(1);
  }

  get translationHeadline() {
    let headline;

    if (this.total == 1) {
      headline = this.instance["translation"]["headline_singular"];
    } else {
      headline = this.instance["translation"]["headline_plural"];
    }

    return headline.replace("###count###", this.total);
  }

  public async getProducts(paginationPage) {
    let products = await Api.conversionWorldService.getProducts(
      this.$store.conversionWorldProductFilter.filterWithPageId,
      "vanpartner",
      paginationPage
    );

    this.pagination = products.pagination!;
    if (paginationPage == 1) {
      this.products = products.resultList;
    } else {
      this.products = this.products.concat(products.resultList);
    }
    this.$store.conversionWorld.vanPartnerProductsTotalCount =
      products.pagination!.total_count!;

    this.isLoadingMore = false;
    if (this.currentPage === this.pageCount) {
      this.morePages = false;
    }
  }
}
